import React from 'react';
import ReminderCard from './tabcards/ReminderCard';
import './ReminderSettings.css';

function ReminderSettings() {
    return (
        <div className="ecx-page clinic-settings-page reminder-settings-page ecx-page--full-width">
            <ReminderCard />
        </div>
    );
}

export default ReminderSettings;
